import { connect } from 'react-redux'
import SurchargeTourDetail from "./SurchargeTour";
import * as orderActions from '../../../../../../../actions/orderAction'

const mapStateToProps = state => {
    return {
        // surchargeState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSurchargeDetail: (id) => dispatch(orderActions.getSurchargeDetail(id)),
        setSurchargeDetail: (surcharge) => dispatch(orderActions.setSurchargeDetail(surcharge)),
        createSurchargeDetail: (surcharge) => dispatch(orderActions.createSurchargeDetail(surcharge)),
        updateSurchargeDetail: (surcharge) => dispatch(orderActions.updateSurchargeDetail(surcharge)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(SurchargeTourDetail)